import type { IconSvgObject } from './types';

const ArrowLeftToLineIcon: IconSvgObject = [
  ["path", { d: "M12 7L7 12L12 17M8 12L21 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 6L3 18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default ArrowLeftToLineIcon;
